import { t } from '@lingui/core/macro'
import type { TooltipRow } from 'features/knowledgeDocumentViewer/graph/canvasTypes'
import type { GraphNode } from 'features/knowledgeDocumentViewer/graph/graphTypes'
import {
  isPipeOffPageConnector,
  resolveOffPageConnectorReference,
  resolvePeerOffPageConnector,
} from 'features/knowledgeDocumentViewer/graph/offPageConnectorGraph'

export function buildOffPageConnectorTooltipRows(
  node: GraphNode
): TooltipRow[] {
  if (!isPipeOffPageConnector(node)) return []
  const reference = resolveOffPageConnectorReference(node)?.dexpi
  const byNumber =
    reference?.dexpi_class ===
    'Plant.Piping.PipeOffPageConnectorReferenceByNumber'
      ? reference.attributes
      : undefined

  const rows: TooltipRow[] = []
  if (byNumber?.ReferencedDrawingNumber)
    rows.push({
      label:
        node.dexpi.dexpi_class === 'Plant.Piping.FlowInPipeOffPageConnector'
          ? t`From drawing`
          : t`To drawing`,
      value: byNumber.ReferencedDrawingNumber,
    })
  if (byNumber?.ReferencedConnectorNumber)
    rows.push({
      label: t`Referenced off-page connector`,
      value: byNumber.ReferencedConnectorNumber,
    })
  rows.push({
    label: t`Connection`,
    value: resolvePeerOffPageConnector(node)
      ? t`Matched`
      : byNumber
        ? t`Reference only`
        : t`Unresolved`,
  })
  return rows
}
